import { TOrderStatusEnum } from 'api/orders/orders.types';

const ORDER_STATUS_BASE_SEQUENCE: TOrderStatusEnum[] = [
  TOrderStatusEnum.Created,
  TOrderStatusEnum.Payed,
  TOrderStatusEnum.InProgress,
  TOrderStatusEnum.InDelivery,
  TOrderStatusEnum.Done,
];

export function getOrderStatusSequence(
  status: TOrderStatusEnum
): TOrderStatusEnum[] {
  if (status === TOrderStatusEnum.Refunded) {
    return [...ORDER_STATUS_BASE_SEQUENCE, TOrderStatusEnum.Refunded];
  }
  return ORDER_STATUS_BASE_SEQUENCE;
}

export function getRingColumnClassName(
  isActive: boolean,
  isCompleted: boolean,
  isRefundedActive: boolean
): string {
  return [
    'admin-order-status-progress__ring-column',
    isActive ? 'admin-order-status-progress__ring-column--active' : '',
    isCompleted ? 'admin-order-status-progress__ring-column--completed' : '',
    isRefundedActive
      ? 'admin-order-status-progress__ring-column--refunded-active'
      : '',
  ]
    .filter(Boolean)
    .join(' ');
}

export function getLabelCellClassName(
  isActive: boolean,
  isCompleted: boolean,
  isRefundedActive: boolean
): string {
  return [
    'admin-order-status-progress__label-cell',
    isActive ? 'admin-order-status-progress__label-cell--active' : '',
    isCompleted ? 'admin-order-status-progress__label-cell--completed' : '',
    isRefundedActive
      ? 'admin-order-status-progress__label-cell--refunded-active'
      : '',
  ]
    .filter(Boolean)
    .join(' ');
}

export const orderStatusToLabelKey: Record<TOrderStatusEnum, string> = {
  [TOrderStatusEnum.Created]: 'admin.orders.status.created',
  [TOrderStatusEnum.Payed]: 'admin.orders.status.payed',
  [TOrderStatusEnum.InProgress]: 'admin.orders.status.inprogress',
  [TOrderStatusEnum.InDelivery]: 'admin.orders.status.indelivery',
  [TOrderStatusEnum.Done]: 'admin.orders.status.done',
  [TOrderStatusEnum.Refunded]: 'admin.orders.status.refunded',
};
